import React, {useState} from "react";
import { useLocation } from "react-router-dom";
import {
  Container,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Avatar,
  Button,
  Modal,
} from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import {
  Note,
  AttachMoney,
  School,
  House,
  MenuBook,
  PeopleOutline,
  Star,
} from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { addBookmark, removeBookmark } from "../../redux/firebaseCalls";
import { useAuth } from "../../contexts/AuthContext";

import CardResultList from "../home/Components/CardResultList";
import CardResultText from "../home/Components/CardResultText";

import univData from "../../univdata.json";
import univBackground from "../../univbackground.jpg";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: "100%",
    position: "relative",
    top: "60px",
    paddingTop: "10px",
    paddingBottom: theme.spacing(3),
  },
  bookmark: {
    position: "absolute",
    top: theme.spacing(3),
    right: theme.spacing(5),
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.75),
    },
  },
  starIcon: {
    color: (props) => (props.bookmark ? "#F6BE00" : "grey"),
  },
  avatar: {
    position: "absolute",
    left: 0,
    right: 0,
    marginLeft: "auto",
    marginRight: "auto",
    top: theme.spacing(30),
    height: theme.spacing(20),
    width: theme.spacing(20),
    fontSize: 35,
  },
  topCard: {
    marginBottom: theme.spacing(5),
  },
  cardMedia: {
    height: theme.spacing(40),
  },
  cardContent: {
    paddingTop: theme.spacing(12),
  },
  cardSpacing: {
    marginBottom: theme.spacing(2),
  },
  modalContainer: {
    position: "absolute",
    width: 500,
    height: 200,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
  },
  modalButtonDiv: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(5)
  },
}));

export default function Info() {
  const location = useLocation();
  const univName = location.pathname.split("/")[2].replaceAll("-", " ");

  const {currentUser} = useAuth();
  const dispatch = useDispatch();
  const bookmarkUniv = useSelector((state) => state.bookmark.bookmarkList);
  const [bookmark, setBookmark] = useState(bookmarkUniv.includes(univName));
  const [openModal, setOpenModal] = useState(false);
  const classes = useStyles({ bookmark });

  const indexFound = univData.findIndex((univ) => univ.name === univName);
  const data = univData[indexFound];

  const handleRemove = () => {
    setBookmark(false);
    removeBookmark(univName, currentUser.uid, dispatch);
    setOpenModal(false);
  };

  const handleBookmark = () => {
    if (!bookmark) {
      setBookmark(true);
      addBookmark(univName, currentUser.uid, dispatch);
    } else {
      setOpenModal(true);
    }
  };

  return (
    <Container maxWidth="lg" className={classes.wrapper}>
      <Card className={classes.topCard}>
        <Button
          endIcon={<Star className={classes.starIcon} />}
          className={classes.bookmark}
          onClick={handleBookmark}
        >
          Add to Bookmark
        </Button>
        <Avatar className={classes.avatar}>NUS</Avatar>
        <CardMedia image={univBackground} className={classes.cardMedia} />
        <CardContent className={classes.cardContent}>
          <Typography variant="h4" align="center" gutterBottom>
            {data.name}
          </Typography>
        </CardContent>
      </Card>
      <div className={classes.cardSpacing}>
        <CardResultList
          title="Documents"
          data={data.document}
          icon={<Note />}
        />
      </div>
      <div className={classes.cardSpacing}>
        <CardResultText title="Fees" data={data.fee} icon={<AttachMoney />} />
      </div>
      <div className={classes.cardSpacing}>
        <CardResultList
          title="Scholarship"
          data={data.scholarship}
          icon={<School />}
        />
      </div>
      <div className={classes.cardSpacing}>
        <CardResultList title="Housing" data={data.housing} icon={<House />} />
      </div>
      <div className={classes.cardSpacing}>
        <CardResultList
          title="Prep. Course"
          data={data.prepcourse}
          icon={<MenuBook />}
        />
      </div>
      <div className={classes.cardSpacing}>
        <CardResultText
          title="Study Group"
          data={data.studygroup}
          icon={<PeopleOutline />}
          button={true}
        />
      </div>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Container className={classes.modalContainer}>
          <Typography variant="h5">
            Are you sure you want to remove this university from your bookmarked
            list?
          </Typography>
          <div className={classes.modalButtonDiv}>
            <Button
              color="secondary"
              variant="contained"
              style={{marginRight: 10}}
              onClick={handleRemove}
            >
              Proceed
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </Button>
          </div>
        </Container>
      </Modal>
    </Container>
  );
}
